import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetExpenseRatesForProjectChargeQueryVariables = Types.Exact<{
  asOf: Types.Scalars['LocalDate'];
  projectNumber: Types.Scalars['Int'];
}>;


export type GetExpenseRatesForProjectChargeQuery = { __typename?: 'QueryModel', projects?: { __typename?: 'ProjectsQueryModelOld', effectiveExpenseRateSheet?: { __typename?: 'ExpenseRateSheet', expenseRates?: Array<{ __typename: 'AdHocExpenseRate', name: string, unit?: Types.RateUnit | null } | { __typename: 'AtvExpenseRate', billableAmount?: number | null, name: string, unit?: Types.RateUnit | null } | { __typename: 'FuelExpenseRate', billable: boolean, name: string, unit?: Types.RateUnit | null } | { __typename: 'MileageExpenseRate', billableAmountPerMile?: number | null, name: string, unit?: Types.RateUnit | null } | { __typename: 'MobileAllowanceExpenseRate', billableAmount?: number | null, quantity: number, name: string, unit?: Types.RateUnit | null } | { __typename: 'PerDiemExpenseRate', kind: Types.PerDiemKind, billableOverride?: number | null, name: string, unit?: Types.RateUnit | null } | { __typename: 'ReceiptValuedExpenseRate', billable: boolean, name: string, unit?: Types.RateUnit | null } | { __typename: 'TcpAllowanceExpenseRate', name: string, unit?: Types.RateUnit | null } | null> | null } | null } | null };


export const GetExpenseRatesForProjectChargeDocument = gql`
    query GetExpenseRatesForProjectCharge($asOf: LocalDate!, $projectNumber: Int!) {
  projects {
    effectiveExpenseRateSheet(asOf: $asOf, projectNumber: $projectNumber) {
      expenseRates {
        name
        unit
        __typename
        ... on ReceiptValuedExpenseRate {
          billable
        }
        ... on FuelExpenseRate {
          billable
        }
        ... on PerDiemExpenseRate {
          kind
          billableOverride
        }
        ... on MobileAllowanceExpenseRate {
          billableAmount
          quantity
        }
        ... on MileageExpenseRate {
          billableAmountPerMile
        }
        ... on AtvExpenseRate {
          billableAmount
        }
      }
    }
  }
}
    `;

/**
 * __useGetExpenseRatesForProjectChargeQuery__
 *
 * To run a query within a React component, call `useGetExpenseRatesForProjectChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpenseRatesForProjectChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpenseRatesForProjectChargeQuery({
 *   variables: {
 *      asOf: // value for 'asOf'
 *      projectNumber: // value for 'projectNumber'
 *   },
 * });
 */
export function useGetExpenseRatesForProjectChargeQuery(baseOptions: Apollo.QueryHookOptions<GetExpenseRatesForProjectChargeQuery, GetExpenseRatesForProjectChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpenseRatesForProjectChargeQuery, GetExpenseRatesForProjectChargeQueryVariables>(GetExpenseRatesForProjectChargeDocument, options);
      }
export function useGetExpenseRatesForProjectChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpenseRatesForProjectChargeQuery, GetExpenseRatesForProjectChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpenseRatesForProjectChargeQuery, GetExpenseRatesForProjectChargeQueryVariables>(GetExpenseRatesForProjectChargeDocument, options);
        }
export type GetExpenseRatesForProjectChargeQueryHookResult = ReturnType<typeof useGetExpenseRatesForProjectChargeQuery>;
export type GetExpenseRatesForProjectChargeLazyQueryHookResult = ReturnType<typeof useGetExpenseRatesForProjectChargeLazyQuery>;
export type GetExpenseRatesForProjectChargeQueryResult = Apollo.QueryResult<GetExpenseRatesForProjectChargeQuery, GetExpenseRatesForProjectChargeQueryVariables>;